<template>
  <div>
    <div @click="openPanel" class="cursor-pointer">
      <slot
        name="header"
        :state="expandState"
        :show-icon="staticPanel"
        :openPanel="openPanel"
        :close="close"
      />
    </div>
    <div class="">
      <slot name="static" />
    </div>
    <TransitionExpand>
      <div v-show="expandState" class="px-2 py-4">
        <slot name="content" :close="close" :state="expandState" />
      </div>
    </TransitionExpand>
  </div>
</template>

<script setup>
import { onMounted, inject, ref, computed, watch, nextTick } from "vue";
import { TransitionExpand } from "@morev/vue-transitions";
const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
  staticPanel: {
    type: Boolean,
    default: false,
  },
});
const keyId = ref(null);
const toggleExpand = inject("toggleExpand");
const toggleState = inject("toggleState");

const expandState = computed(() => {
  return toggleState.value.includes(keyId.value);
});

const close = () => {
  toggleExpand(keyId.value);
};
const openPanel = () => {
  if (props.staticPanel) return;
  toggleExpand(keyId.value);
};

const uuidv4 = () => crypto.randomUUID();
watch(
  () => props.staticPanel,
  (v) => {
    toggleExpand(keyId.value);
  },
  {
    immediate: false,
  },
);

onMounted(() => {
  keyId.value = uuidv4();
  if (props.open) {
    toggleExpand(keyId.value);
  }
});
</script>
